import { useMemo } from 'react';
import mapValueToDependencies from '../utils/map-value-to-dependencies.js';
export default function useShallowMemo(obj) {
    return useMemo(() => obj, mapValueToDependencies(obj));
}
//# sourceMappingURL=use-shallow-memo.js.map